export default __webpack_public_path__ + "static/media/01_photo.42354e4b.jpg";